import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip, Typography } from '@mui/material'

const AllergensInfo: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Tooltip title={t('allergens:info')}>
      <Typography width="fit-content" variant="body1" color="info.main">
        {t('cc:haveAnAllergy')}
      </Typography>
    </Tooltip>
  )
}

export default AllergensInfo
